import React, {useEffect, useState} from 'react';
import { getAccessToken } from '../authHelper';

// ======== 复制按钮相关图片 ========
import copy_img from '../../tables/static_files/copy inner hover.svg';
import copy_hover_img from '../../tables/static_files/copy inner.svg';
import copy_success_img from '../../tables/static_files/copy success.svg';

const EmailUIDTxsRequestsTable = ({selectedChain, onChainSelect}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [copyState, setCopyState] = useState({});
    const [balances, setBalances] = useState([]);
    const [balancesLoading, setBalancesLoading] = useState(true);
    const [balancesError, setBalancesError] = useState(null);
    const [balancesPage, setBalancesPage] = useState(1);
    const [balancesPageSize, setBalancesPageSize] = useState(50);
    const [balancesHasMore, setBalancesHasMore] = useState(false);

    // ================== 大小写转换辅助函数 ==================
    const formatStatus = (status) => {
        if (!status) return "";
        const parts = status.split("_");
        const capitalizedParts = parts.map(part =>
            part.charAt(0).toUpperCase() + part.slice(1)
        );
        return capitalizedParts.join(" ");
    };
    const formatTxsType = (type) => {
        if (!type) return "";
        return type.charAt(0).toUpperCase() + type.slice(1);
    };
    const formatChain = (chain) => {
        if (!chain) return "";
        return chain.charAt(0).toUpperCase() + chain.slice(1);
    };
    const formatNetwork = (network) => {
        if (network === "c2c") return "C2C";
        if (network === "blockchain") return "Blockchain";
        return network;
    };
    const formatMethod = (method) => {
        if (method === "cash") return "Cash";
        if (method === "usdc") return "USDC";
        if (method === "usdt") return "USDT";
        return method;
    };

    // ================== 点击 status 时的逻辑 ==================
    const handleStatusClick = async (email_uid_user_txs_id) => {
        try {
            const transaction_signature = window.prompt("Please enter the transaction signature:");
            if (!transaction_signature) return;

            const confirmComplete = window.confirm(
                `Are you sure you want to complete for email_uid_user_txs_id： ${email_uid_user_txs_id}?`
            );
            if (!confirmComplete) return;

            console.log("email_uid_user_txs_id", email_uid_user_txs_id);
            const response = await fetch(
                "https://usdi-api-jlukzyz7wa-ew.a.run.app/execute_email_uid_txs_requests",
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        email_uid_user_txs_id,
                        transaction_signature
                    }),
                }
            );
            if (!response.ok) {
                throw new Error("Request failed. Please verify the transaction signature.");
            }

            await fetchData();
            alert("Request executed successfully!");
        } catch (err) {
            alert("Error: " + err.message);
        }
    };

    // ================== 分页辅助函数 ==================
    const getPageNumbers = (currentPage, totalPages) => {
        const maxPageButtons = 5;
        const pageNumbers = [];
        if (totalPages <= maxPageButtons) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1);
            let left = currentPage - 1;
            let right = currentPage + 1;
            if (left > 2) {
                pageNumbers.push('...');
            } else {
                left = 2;
            }
            if (right < totalPages - 1) {
                for (let i = left; i <= right; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
            } else {
                for (let i = left; i <= totalPages - 1; i++) {
                    pageNumbers.push(i);
                }
            }
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // ================== 分页状态 ==================
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // ================== Status filter ==================
    const [statusFilter, setStatusFilter] = useState('all'); // 'all' | 'pending' | 'executed' | 'cancelled'

    // ================== 拉取数据 ==================
    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://usdi-api-jlukzyz7wa-ew.a.run.app/get_email_uid_txs_requests');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            // Log is_test data presence
            const rows = Array.isArray(result) ? result : [];
            const withIsTest = rows.filter((r) => 'is_test' in r).length;
            const withTrue = rows.filter((r) => r.is_test === true).length;
            const withFalse = rows.filter((r) => r.is_test === false).length;
            setData(result);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBalances = async ({refresh = false} = {}) => {
        try {
            setBalancesLoading(true);
            setBalancesError(null);
            const access_token = await getAccessToken();
            if (!access_token) {
                setBalances([]);
                setBalancesHasMore(false);
                setBalancesLoading(false);
                return;
            }
            const params = new URLSearchParams({
                page: String(balancesPage),
                page_size: String(balancesPageSize),
                refresh: String(refresh),
            });
            const response = await fetch(
                `https://usdi-api-jlukzyz7wa-ew.a.run.app/email_user_balances?${params.toString()}`,
                { headers: { Authorization: `Bearer ${access_token}` } }
            );
            if (!response.ok) {
                const errorPayload = await response.json().catch(() => ({}));
                throw new Error(errorPayload?.error || 'Failed to fetch balances');
            }
            const result = await response.json();
            const rows = Array.isArray(result) ? result : [];
            setBalances(rows);
            setBalancesHasMore(rows.length === balancesPageSize);
        } catch (err) {
            setBalancesError(err);
        } finally {
            setBalancesLoading(false);
        }
    };

    // 组件挂载时获取数据
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchBalances();
    }, [balancesPage, balancesPageSize]);

    // data 或 filter 改变时回到第 1 页
    useEffect(() => {
        setCurrentPage(1);
    }, [data, statusFilter]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    // ================== Filter by status + is_test ==================
    const filteredData = data.filter((row) => {
        const s = (row.status || '').toLowerCase();

        // Special mental logic: when filtering by "Test", show ONLY test rows
        if (statusFilter === 'test') {
            return row.is_test === true;
        }

        // For all other filters, exclude test rows
        if (row.is_test === true) return false;

        if (statusFilter === 'all') return true;
        if (statusFilter === 'pending') return s === 'deposited' || s === 'requested';
        if (statusFilter === 'executed') return s === 'executed';
        if (statusFilter === 'cancelled') return s === 'cancelled' || s === 'canceled';
        return true;
    });

    // ================== 计算分页数据 ==================
    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handlePageChange = (page) => {
        if (page < 1) page = 1;
        if (page > totalPages) page = totalPages;
        setCurrentPage(page);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = filteredData.slice(startIndex, endIndex);
    const pageNumbers = getPageNumbers(currentPage, totalPages);

    // ================== 复制逻辑 ==================

    const handleMouseEnter = (rowIndex, field) => {
        setCopyState((prev) => {
            const key = `${rowIndex}_${field}`;
            if (prev[key] === "success") {
                return prev; // 如果已经是成功状态，则不变
            }
            return {...prev, [key]: "hover"};
        });
    };

    const handleMouseLeave = (rowIndex, field) => {
        setCopyState((prev) => {
            const key = `${rowIndex}_${field}`;
            if (prev[key] === "success") {
                return prev; // 成功状态就不恢复
            }
            return {...prev, [key]: "default"};
        });
    };

    const handleCopyClick = (textToCopy, rowIndex, field) => {
        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                const key = `${rowIndex}_${field}`;
                setCopyState((prev) => ({...prev, [key]: "success"}));
                // 2秒后恢复 default
                setTimeout(() => {
                    setCopyState((prev2) => {
                        if (prev2[key] === "success") {
                            return {...prev2, [key]: "default"};
                        }
                        return prev2;
                    });
                }, 2000);
            })
            .catch((err) => {
                console.error("copy failed:", err);
            });
    };

    const getCopyIcon = (rowIndex, field) => {
        const state = copyState[`${rowIndex}_${field}`];
        if (state === "hover") return copy_hover_img;
        if (state === "success") return copy_success_img;
        return copy_img;
    };

    // ================== 渲染 ==================
    return (
        <div>
            <div style={{marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px'}}>
                <label style={{color: '#FFFFFFCC', fontSize: '14px'}}>Filter by status:</label>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="status_dropdown"
                    style={{padding: '6px 12px', minWidth: '140px'}}
                >
                    <option value="all">All</option>
                    <option value="pending">Pending</option>
                    <option value="executed">Executed</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="test">Test</option>
                </select>
            </div>
            <div className="table-responsive noto">
                <table className="table table-striped table-bordered mt-3 email-uid-txs-table">
                    <thead className="thead-dark">
                    <tr>
                        <th>Email UID User Request ID</th>
                        <th>Status</th>

                        <th>Email</th>
                        <th>From Token Amount</th>
                        <th>Txs Type</th>
                        <th>Payment Method Name</th>
                        <th>To_Address</th>
                        {/* （原先 status 列被移除） */}
                        <th>Requested Timestamp UTC</th>
                        <th>From Token Address</th>
                        <th>To Token Address</th>
                        <th>To Token Amount</th>
                        <th>From_Address</th>
                        <th>method</th>
                        <th>chain</th>
                        <th>Network</th>
                        <th>fees %</th>
                        <th>Network Fees</th>
                        <th>Redeem Amount After Fees</th>
                        <th>ETA</th>
                        <th>Executed Timestamp</th>
                        <th>Payment Info ID</th>
                        <th>Payment Method Detail</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.map((row, index) => {
                        const statusLower = (row.status || '').toLowerCase();
                        const isRowCancelled = statusLower === 'cancelled' || statusLower === 'canceled';
                        return (
                        <tr
                            key={index}
                            className={isRowCancelled ? 'cancelled-row' : undefined}
                        >
                            {/* 1) ID + (status) */}
                            <td style={{minWidth: '120px'}}>
                                {row.email_uid_user_txs_id}{" "}

                            </td>
                            {(() => {
                                const isExecuted = statusLower === 'executed';
                                const statusColor = isRowCancelled ? '#888888' : (isExecuted ? '#6CE3C4' : '#E3CF6C');
                                const isClickable = !isExecuted && !isRowCancelled;
                                return (
                                    <td
                                        style={{
                                            color: statusColor,
                                            cursor: isClickable ? 'pointer' : 'default',
                                        }}
                                        onClick={isClickable ? () => handleStatusClick(row.email_uid_user_txs_id) : undefined}
                                    >
                                        {formatStatus(row.status)}
                                    </td>
                                );
                            })()}

                            <td>{row.email}</td>

                            {row.from_token_amount ? (
                                <td>{parseFloat(row.from_token_amount).toFixed(6)}</td>
                            ) : (
                                <td></td>
                            )}

                            <td>{formatTxsType(row.txs_type)}</td>
                            <td>{row.payment_method}</td>

                            {/* 2) to_address + copy按钮 - force same vertical alignment as other columns */}
                            <td className="td-to-address" style={{verticalAlign: 'middle', paddingTop: 0, paddingBottom: 0}}>
                                <span style={{display: 'inline-flex', alignItems: 'center', lineHeight: 1}}>
                                    {row.to_address}
                                    {row.to_address && (
                                        <img
                                            src={getCopyIcon(index, "to_address")}
                                            alt="copy"
                                            style={{
                                                width: 16,
                                                height: 16,
                                                marginLeft: 8,
                                                cursor: "pointer",
                                                verticalAlign: 'middle',
                                                flexShrink: 0,
                                            }}
                                            onMouseEnter={() => handleMouseEnter(index, "to_address")}
                                            onMouseLeave={() => handleMouseLeave(index, "to_address")}
                                            onClick={() => handleCopyClick(row.to_address, index, "to_address")}
                                        />
                                    )}
                                </span>
                            </td>

                            {/* （原先 status td 移除） */}
                            <td>{row.requested_timestamp}</td>
                            <td>{row.from_token_address}</td>
                            <td>{row.to_token_address}</td>
                            <td>{row.to_token_amount}</td>

                            {/* 3) from_address + copy按钮 */}
                            <td style={{display: 'flex', alignItems: 'center', height: "76.42px"}}>
                                {row.from_address}
                                {row.from_address && (
                                    <img
                                        src={getCopyIcon(index, "from_address")}
                                        alt="copy"
                                        style={{
                                            width: 16,
                                            height: 16,
                                            marginLeft: 8,
                                            cursor: "pointer",
                                        }}
                                        onMouseEnter={() => handleMouseEnter(index, "from_address")}
                                        onMouseLeave={() => handleMouseLeave(index, "from_address")}
                                        onClick={() => handleCopyClick(row.from_address, index, "from_address")}
                                    />
                                )}
                            </td>

                            <td>{formatMethod(row.method)}</td>
                            <td>{formatChain(row.chain)}</td>
                            <td>{formatNetwork(row.network)}</td>

                            {row.fees_percent ? (
                                <td>{parseFloat(row.fees_percent).toFixed(2)}%</td>
                            ) : (
                                <td></td>
                            )}
                            {row.network_fees ? (
                                <td>{parseFloat(row.network_fees).toFixed(2)}</td>
                            ) : (
                                <td></td>
                            )}
                            {row.redeem_amount_after_fees ? (
                                <td>{parseFloat(row.redeem_amount_after_fees).toFixed(2)}</td>
                            ) : (
                                <td></td>
                            )}
                            <td>{row.eta}</td>
                            <td>{row.executed_timestamp || ''}</td>
                            <td>{row.payment_info_id}</td>
                            <td>{row.payment_info_detail}</td>
                        </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            {/* ================== 分页控件 ================== */}
            {totalPages > 0 && (
                <div className="pagination-container">
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                        id="first-page-button"
                    >
                        First
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>

                    {pageNumbers.map((p, i) =>
                        p === '...' ? (
                            <span key={i} className="pagination-ellipsis">
                                ...
                            </span>
                        ) : (
                            <button
                                key={i}
                                className={`pagination-button ${p === currentPage ? 'active-page' : ''}`}
                                onClick={() => handlePageChange(p)}
                            >
                                {p}
                            </button>
                        )
                    )}

                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        id="last-page-button"
                    >
                        Last
                    </button>
                </div>
            )}

            <div className="pagination-outer-container" style={{marginTop: 24}}>
                <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                    <button
                        className="tableDownloadButton"
                        onClick={() => {
                            fetchBalances({refresh: true});
                        }}
                    >
                        Refresh Balances (This Page)
                    </button>
                    <span>Page</span>
                    <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={balancesPage <= 1}
                        onClick={() => setBalancesPage((prev) => Math.max(1, prev - 1))}
                    >
                        Prev
                    </button>
                    <span>{balancesPage}</span>
                    <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={!balancesHasMore}
                        onClick={() => setBalancesPage((prev) => prev + 1)}
                    >
                        Next
                    </button>
                    <span>Page Size</span>
                    <select
                        className="form-control"
                        style={{width: 120}}
                        value={balancesPageSize}
                        onChange={(e) => {
                            const nextSize = Number(e.target.value);
                            setBalancesPage(1);
                            setBalancesPageSize(nextSize);
                        }}
                    >
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={500}>500</option>
                    </select>
                </div>
            </div>

            {balancesLoading && <div>Loading balances...</div>}
            {balancesError && <div>Error: {balancesError.message}</div>}
            {!balancesLoading && !balancesError && (
                <div className="table-responsive noto">
                    <table className="table table-striped table-bordered mt-3">
                        <thead className="thead-dark">
                        <tr>
                            <th>Email</th>
                            <th>Wallet Address</th>
                            <th>USDC Balance</th>
                            <th>USDT Balance</th>
                            <th>USDi Balance</th>
                            <th>Updated At (UTC)</th>
                        </tr>
                        </thead>
                        <tbody>
                        {balances.length > 0 ? (
                            balances.map((row) => (
                                <tr key={`${row.email}-${row.wallet_address}`}>
                                    <td>{row.email ?? ''}</td>
                                    <td>{row.wallet_address ?? ''}</td>
                                    <td>{row.usdc_balance ?? ''}</td>
                                    <td>{row.usdt_balance ?? ''}</td>
                                    <td>{row.usdi_balance ?? ''}</td>
                                    <td>{row.updated_at ?? ''}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">No balances found.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default EmailUIDTxsRequestsTable;
